import PrestationsController from './prestations.controller';

export default {
    template: require('./prestations.tpl.html'),
    controller: PrestationsController
};
